import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import './style.scss'

const SelectedValue = ({
    header,
    field,
    selectedValues,
    onRemove
}) => {
    const values = selectedValues.split(';');
    const hasSelected = selectedValues !== '' && values.length > 0;

    return (
        <div className="selected-values">
            {header && <h4 className="trip-modal__title trip-modal__title--small">{ header }</h4>}
            {hasSelected &&
                <div className="selected-values__content">
                    {values.map((value) => {
                        let btnLabel = value;

                        // Sprawdź czy wartość zawiera "Wyc. Objazdowe" - wtedy wyświetl pełną nazwę
                        const lowerValue = value.toLowerCase();
                        if (lowerValue.includes('wyc. objazdowe') || lowerValue.includes('objazdowa')) {
                            // Dla "Wyc. Objazdowe" wyświetl pełną nazwę (część po pierwszej kropce)
                            const parts = value.split('.');
                            if (parts.length >= 2) {
                                // Połącz wszystkie części po pierwszej kropce (kraju)
                                btnLabel = parts.slice(1).join('.');
                            }
                        } else {
                            const valueParts = value.split('.');
                            
                            if (valueParts.length === 3) {
                                btnLabel = valueParts[2];
                            } else if (valueParts.length === 2) {
                                btnLabel = valueParts[1];
                            }
                        }

                        return (
                            <Button
                                key={value}
                                variant="remove"
                                type="button"
                                label={btnLabel}
                                clickHandler={() => onRemove(field, value)}
                            />
                        )
                    })}
                </div>
            }
        </div>
    );
};

SelectedValue.propTypes = {
    header: PropTypes.string,
    field: PropTypes.string,
    selectedValues: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
};

export default SelectedValue
